import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["accountsPayableGlAccountExternalId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { Typography, Button, Autocomplete, TextField, Grid, Accordion, AccordionDetails, AccordionSummary, ToggleButtonGroup, ToggleButton, MenuItem, Select, IconButton, InputAdornment } from '@mui/material';
import { Icon, InputWithIcon,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// SelectMenu,
toast, BackdropLoader, CONSTANTS, ExpandedTooltip } from '@livable/saas-react-components';
import BillFrequencyModal from './BillFrequencyModal';
import AllocationMethodModal from './AllocationMethodModal';
import VacantUnitBills from './VacantUnitBills';
import CADModal from './CADModal';
import { ListItem } from './UtilityAccordion/listItem';
import { UtilitiesAutocomplete } from './UtilitiesAutocomplete';
// NOTE: Hidden Auto billing feature until further development
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import useBillingTemplateModalContentStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { ALLOCATION_METHOD, BILL_FREQUENCY_NAME, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY, VACANT_UNIT_USAGE, VACANT_UNIT_USAGE_TO_TRANSLATE, vacantUnitOccupantsSummarySuffix } from 'src/constants/utilities';
import GLModal from './GLModal';
import { AddNewRateModal } from './AddNewRateModal';
import { MapColumnsModal, MapColumnsViewModal, MapColumnsEditModal, COLUMN_FIELD_MAP } from './MapColumnsModal';
import { ProvideUnitMeterIDsModal } from './ProvideUnitMeterIDsModal';
import { SubmeterDisclosures, DISCLOSURE_FIELDS } from './SubmeterDisclosures';
import { getMethodLockRefusal, METHOD_LOCK_TOAST_TITLE } from 'src/utils/methodLockRefusal';
import { toJS } from 'mobx';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { ProviderSetupPlain } from 'src/components/property/PropertyUtilitiesSetupPageV2/ProviderSetupModal/plain';
import { AddProviderPlain } from 'src/components/property/PropertyUtilitiesSetupPageV2/AddProviderModalV2/plain';
import { AssociatedVendor } from 'src/components/shared/AssociatedVendor';
import { ApPushSwitch } from 'src/components/ApPushSwitch';
import { BillReadyDayField } from 'src/components/BillReadyDayField';
import { UtilitySetupSection } from 'src/components/UtilitySetupSection';
import { billingValuesOf, SetOnSetupNote, SetupOnSaveNote, setupOwnsBillingOptions } from 'src/components/UtilitySetupSection/ownership';
import { UtilityCredentialSlot } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialSlot';
import { EMPTY_PENDING_CREDENTIAL } from 'src/components/property/UtilityPortalCredentials/PendingCredentialFields';
import { savePendingCredential } from 'src/components/property/UtilityPortalCredentials/savePendingCredential';
import { onCredentialsChanged } from 'src/components/property/UtilityPortalCredentials/credentialEvents';
import { api } from 'src/api';
import { NO_OPTIONS } from 'src/stores/utilitySetups/companySetupsRead';
import { isScraperSupported } from 'src/components/property/UtilityPortalCredentials/credentialStatus';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
import { canManageUtilityCredentials } from 'src/utils/canManageUtilityCredentials';
import { noteColumnMapChange } from 'src/pages/NewBillingModule/OldUtilityConfigurationModal/columnMapVersion';

/** Backend may send 0.55 (decimal) or 55 (percentage). Returns integer 0-100 for display. */
function formatVacantUnitUsageLimitPercent(value) {
  const n = Number(value !== null && value !== void 0 ? value : 0);
  if (Number.isNaN(n)) return 0;
  return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
}
export const ModalContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _utility$provider12, _utility$provider14, _utility$provider15, _utility$provider16, _utility$provider17, _utility$provider18, _utility$provider19, _store$addNewProperty2, _store$homeDashboardS39, _store$homeDashboardS40, _store$addNewProperty3, _store$addNewProperty4;
  let utility = _ref.utility,
    isEditing = _ref.isEditing,
    handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles({
    modalHasNoMargin: true,
    modalHasNoPadding: true
  });
  const classes = useBillingTemplateModalContentStyles();
  const isSubmeterEnabled = store.account.featureFlagsStore.getEnableSubmeterBilling;
  const _useState = useState('gal'),
    _useState2 = _slicedToArray(_useState, 2),
    unitOfMeasure = _useState2[0],
    setUnitOfMeasure = _useState2[1];
  const handleUnitOfMeasureChange = event => {
    if (event.target.value) setUnitOfMeasure(event.target.value);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isProviderSetupModalOpen = _useState4[0],
    setProviderSetupModalOpen = _useState4[1];
  const _useState5 = useState(() => utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS'),
    _useState6 = _slicedToArray(_useState5, 2),
    billingMethodType = _useState6[0],
    setBillingMethodType = _useState6[1];
  useEffect(() => {
    setBillingMethodType(utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS');
  }, [utility.allocationMethod]);
  const handleChangeMethodType = (event, value) => {
    event.preventDefault();
    if (value) setBillingMethodType(value);
  };
  const getDefaultUtilitySettings = (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.getUtilityInfoById(isEditing ? utility.utilityId : utility === null || utility === void 0 ? void 0 : utility.utilityTypeId);
  const isDefaultBySetting = settingName => {
    switch (settingName) {
      case 'allocationMethod':
        {
          return (getDefaultUtilitySettings === null || getDefaultUtilitySettings === void 0 ? void 0 : getDefaultUtilitySettings.defaultAllocationMethod) === utility.allocationMethod;
        }
      case 'vacantUnitUsage':
        {
          return (getDefaultUtilitySettings === null || getDefaultUtilitySettings === void 0 ? void 0 : getDefaultUtilitySettings.defaultVacantUnitUsage) === utility.vacantUnitUsage;
        }
      case 'commonAreaDeduction':
        {
          return getDefaultUtilitySettings !== null && getDefaultUtilitySettings !== void 0 && getDefaultUtilitySettings.cad ? utility.commonAreaDeduction === 5 : utility.commonAreaDeduction === 0;
        }
    }
  };

  // NOTE: Might be used for initial state on accordion
  // const isAllUtilityConfigDefault = () => {
  //   return (
  //     isDefaultBySetting('allocationMethod') &&
  //     isDefaultBySetting('vacantUnitUsage') &&
  //     isDefaultBySetting('commonAreaDeduction')
  //   );
  // };

  const _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isOpen = _useState8[0],
    setIsOpen = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isLoading = _useState0[0],
    setIsLoading = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isSaving = _useState10[0],
    setIsSaving = _useState10[1];

  // Utility portal credentials, for property managers and staff: the same PmRegularOrHigher the API enforces.
  //
  // In this modal `utility.id` IS the propertyUtilityId (see the save and submeter calls below),
  // except on the add path where it is the 'NEW_UTILITY_TEMPLATE' sentinel.
  const canManageCredentials = canManageUtilityCredentials();
  const isNewUtility = utility.id === 'NEW_UTILITY_TEMPLATE';
  const propertyUtilityId = isNewUtility ? null : utility.id;
  const propertyId = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id;
  // companyId is the selected company in local storage - the same source store.admin reads. An
  // impersonating admin therefore writes against the company they are acting as, which is the intent.
  const companyId = currentCompanyId();
  // Both sources: the edit path has utility.provider, the add path only has the configurator.
  const isScraperSupportedProvider = isScraperSupported(utility.provider, store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator);
  const pendingCredentialRef = useRef(_objectSpread({}, EMPTY_PENDING_CREDENTIAL));

  // With billing options on, the utility's setup in AP Push's place (LB-6186). Its allocation method and frequency are
  // the setup's: this form shows them, a link applied at once writes them into it, and Save waits while a link runs.
  // property-service keeps a linked utility's own on Save in any case.
  const isBillingOptionsEnabled = !!store.account.featureFlagsStore.getIsBillingOptionsEnabled;
  const _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    followsSetup = _useState12[0],
    setFollowsSetup = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    setupWriting = _useState14[0],
    setSetupWriting = _useState14[1];
  // The setup shows this utility's portal login (LB-6191): the modal's own login block stays out, so there's one.
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    setupShowsLogin = _useState16[0],
    setSetupShowsLogin = _useState16[1];
  // The setup couldn't be read, or can't be shown to this user: the section then shows no login, so this one's own stays.
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    setupUnread = _useState18[0],
    setSetupUnread = _useState18[1];
  const noteSetupRead = answer => {
    setFollowsSetup(!!(answer !== null && answer !== void 0 && answer.setup));
  };
  const billingOptionsOnSetup = setupOwnsBillingOptions({
    enabled: isBillingOptionsEnabled,
    isSaved: !isNewUtility,
    followsSetup
  });
  const takeSetupValues = setup => {
    var _utility$setAllocatio, _utility$setBillFrequ;
    const _billingValuesOf = billingValuesOf(setup),
      allocationMethod = _billingValuesOf.allocationMethod,
      billFrequencyType = _billingValuesOf.billFrequencyType;
    (_utility$setAllocatio = utility.setAllocationMethod) === null || _utility$setAllocatio === void 0 || _utility$setAllocatio.call(utility, allocationMethod);
    (_utility$setBillFrequ = utility.setBillFrequencyType) === null || _utility$setBillFrequ === void 0 || _utility$setBillFrequ.call(utility, billFrequencyType);
  };
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    utilityCredential = _useState20[0],
    setUtilityCredential = _useState20[1];
  // 'loading' until this modal's own lookup answers. The request is silent, so isError is the
  // only signal that "no credential" actually means "could not tell", and starting at 'ready'
  // would offer the capture form during the window before the answer arrives.
  const _useState21 = useState('loading'),
    _useState22 = _slicedToArray(_useState21, 2),
    credentialState = _useState22[0],
    setCredentialState = _useState22[1];
  const loadCredential = async () => {
    if (!canManageCredentials || !propertyUtilityId) return;
    try {
      const resp = await store.admin.getUtilityCredentialsAsync.run({
        companyId,
        propertyId,
        propertyUtilityId
      });
      // run() resolves undefined both when the request failed and when a newer call on this
      // shared model cancelled it. A cancellation never sets isError, so trusting that flag
      // would classify an unanswered lookup as ready and offer the capture form.
      if (resp === undefined) {
        setCredentialState('unavailable');
        setUtilityCredential(null);
        return;
      }
      const rows = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      setCredentialState('ready');
      setUtilityCredential(Array.isArray(rows) ? rows[0] || null : null);
    } catch (error) {
      // Never block the utility template on the credential lookup - the template is the primary job
      // of this modal and must stay editable if the credential service is unavailable.
      setCredentialState('unavailable');
      setUtilityCredential(null);
    }
  };
  useEffect(() => {
    // companyId is in the key on purpose: an impersonating admin can switch company while
    // this modal stays mounted, and without it the previous tenant's credential stays on
    // screen and editable against the new one.
    setCredentialState('loading');
    setUtilityCredential(null);
    loadCredential();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canManageCredentials, companyId, propertyUtilityId]);

  // With billing options on, the setup holds the login while it's being read, while the utility follows a setup, and while
  // it shows the login after a refused link (LB-6191). Under a setup on another source the login isn't used, and this block
  // read as a second way bills come in beside it, so it stays out (LB-6195); a portal setup shows the login itself. A
  // utility that follows no setup keeps it here, and so does a setup read that failed or was refused, as the section then
  // shows only that.
  const setupHoldsLogin = isBillingOptionsEnabled && !isNewUtility && !setupUnread && (followsSetup !== false || setupShowsLogin);
  // A login saved in the setup section meanwhile is read again, so the block shows it when it's back. Straight from the
  // API: the page reads its logins again on the same event through the shared store model, which would cancel this read
  // and leave the block saying the login couldn't be loaded. While the block is on screen its own saves read it.
  const credentialReload = useRef(null);
  credentialReload.current = {
    held: setupHoldsLogin && canManageCredentials && !!propertyUtilityId,
    key: "".concat(companyId, "|").concat(propertyUtilityId),
    query: {
      companyId,
      propertyId,
      propertyUtilityId
    }
  };
  useEffect(() => onCredentialsChanged(async () => {
    const _credentialReload$cur = credentialReload.current,
      held = _credentialReload$cur.held,
      key = _credentialReload$cur.key,
      query = _credentialReload$cur.query;
    if (!held) return;
    // An answer for a company or utility this modal has since left is dropped.
    const stillCurrent = () => credentialReload.current.key === key;
    try {
      var _resp$response;
      const resp = await api.AdminApi.getUtilityCredentials(query, NO_OPTIONS);
      if (!stillCurrent()) return;
      const rows = (_resp$response = resp === null || resp === void 0 ? void 0 : resp.response) !== null && _resp$response !== void 0 ? _resp$response : resp;
      if (!Array.isArray(rows)) throw new Error('No portal login answer');
      setCredentialState('ready');
      setUtilityCredential(rows[0] || null);
    } catch (_unused) {
      if (!stillCurrent()) return;
      setCredentialState('unavailable');
      setUtilityCredential(null);
    }
  }), []);
  const _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    consumptionTiers = _useState24[0],
    setConsumptionTiers = _useState24[1];
  const _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    rates = _useState26[0],
    setRates = _useState26[1];
  const _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    mappings = _useState28[0],
    setMappings = _useState28[1];
  const _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    activeCsvColumnMapId = _useState30[0],
    setActiveCsvColumnMapId = _useState30[1];
  const _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isActiveMapKnown = _useState32[0],
    setIsActiveMapKnown = _useState32[1];
  // The one guard on the active template. activeMapWritesRef (and isActiveMapKnown, which gates the
  // buttons) decide whether a config read may overwrite what a set-active wrote. activeMapRef is the
  // same lookup as plain values, because MapColumnsModal calls the onSave it captured when Save was
  // clicked and a state value read there is stale. phase is 'loading' | 'known' | 'unknown'; queuedId
  // is the first template saved before the read returned; writing counts set-active requests in flight.
  // 'failed' once either mapping read fails, and it stays there until the reads start again.
  const _useState33 = useState('loading'),
    _useState34 = _slicedToArray(_useState33, 2),
    templateRead = _useState34[0],
    setTemplateRead = _useState34[1];
  // Which reads of the effect below have answered, success or failure. The Meter IDs dialog has to open on the
  // active mapping, in the right Provide or Edit mode, and read only if a read failed, so its trigger waits for
  // all three.
  const _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    listSettled = _useState36[0],
    setListSettled = _useState36[1];
  const _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    configSettled = _useState38[0],
    setConfigSettled = _useState38[1];
  const _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    countSettled = _useState40[0],
    setCountSettled = _useState40[1];
  const activeMapWritesRef = useRef(0);
  const activeMapRef = useRef({
    phase: 'loading',
    activeId: null,
    queuedId: null,
    writing: 0
  });
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const _useState41 = useState(0),
    _useState42 = _slicedToArray(_useState41, 2),
    meterIdsProvided = _useState42[0],
    setMeterIdsProvided = _useState42[1];
  const _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    disclosures = _useState44[0],
    setDisclosures = _useState44[1];
  const handleChangeDisclosure = (key, value) => setDisclosures(prev => _objectSpread(_objectSpread({}, prev), {}, {
    [key]: value
  }));
  const readsTemplate = !!isSubmeterEnabled && billingMethodType === 'SubMeter' && !!utility.id && utility.id !== 'NEW_UTILITY_TEMPLATE';
  let templateState = 'ready';
  if (readsTemplate) {
    if (!listSettled || !configSettled || !countSettled || store.propertyUtility.updateCsvColumnMapAsync.inProgress) {
      templateState = 'loading';
    } else if (templateRead === 'failed') templateState = 'failed';
  }
  const handleSetActiveMapping = async mappingId => {
    activeMapWritesRef.current += 1;
    activeMapRef.current.writing += 1;
    const writtenFor = utility.id;
    try {
      const resp = await store.propertyUtility.updateCsvColumnMapAsync.run({
        propertyUtilityId: writtenFor,
        csvColumnMapId: mappingId
      });
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
      activeMapWritesRef.current += 1;
      Object.assign(activeMapRef.current, {
        phase: 'known',
        activeId: mappingId
      });
      setActiveCsvColumnMapId(mappingId);
      setIsActiveMapKnown(true);
      noteColumnMapChange(writtenFor);
      toast('success', {
        body: ['Mapping set as active!']
      });
    } finally {
      activeMapRef.current.writing -= 1;
    }
  };
  const autoActivateMapping = mappingId => {
    const lookup = activeMapRef.current;
    if (!isMountedRef.current || lookup.phase !== 'known' || lookup.activeId || lookup.writing > 0) return;
    handleSetActiveMapping(mappingId);
  };
  useEffect(() => {
    if (!readsTemplate) return;
    let isCurrent = true;
    setTemplateRead('loading');
    setListSettled(false);
    setConfigSettled(false);
    setCountSettled(false);
    store.allocations.getSubmeterBillingCsvMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      var _store$homeDashboardS3, _store$homeDashboardS4;
      if (!isCurrent) return;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful) || !Array.isArray(resp.response)) {
        setTemplateRead('failed');
        setListSettled(true);
        return;
      }
      const units = (_store$homeDashboardS3 = (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.unitSetup) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.units) !== null && _store$homeDashboardS3 !== void 0 ? _store$homeDashboardS3 : [];
      const unitIdToName = Object.fromEntries(units.filter(u => u.id && u.name).map(u => [u.id, u.name]));
      const normalized = resp.response.map(m => {
        var _m$unitMappings;
        return _objectSpread(_objectSpread({}, m), {}, {
          columnMappings: COLUMN_FIELD_MAP.reduce((acc, _ref2) => {
            let field = _ref2.field;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [field]: m[field] || ''
            });
          }, {}),
          unitMappings: ((_m$unitMappings = m.unitMappings) !== null && _m$unitMappings !== void 0 ? _m$unitMappings : []).reduce((acc, _ref3) => {
            let unitId = _ref3.unitId,
              identifiers = _ref3.identifiers;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [unitIdToName[unitId] || unitId]: (identifiers === null || identifiers === void 0 ? void 0 : identifiers[0]) || ''
            });
          }, {})
        });
      });
      setMappings(normalized);
      setListSettled(true);
    });
    const writesAtStart = activeMapWritesRef.current;
    activeMapRef.current.phase = 'loading';
    setIsActiveMapKnown(false);
    store.propertyUtility.getSubmeterConfigV2Async.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      var _resp$response3;
      if (!isCurrent) return;
      const queuedId = activeMapRef.current.queuedId;
      activeMapRef.current.queuedId = null;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) {
        setTemplateRead('failed');
        setConfigSettled(true);
        activeMapRef.current.phase = 'unknown';
        return;
      }
      // This read has answered, whether or not a set-active write that started after it makes its result stale.
      setConfigSettled(true);
      setDisclosures(Object.fromEntries(DISCLOSURE_FIELDS.map(_ref4 => {
        var _resp$response$key, _resp$response2;
        let key = _ref4.key;
        return [key, (_resp$response$key = (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2[key]) !== null && _resp$response$key !== void 0 ? _resp$response$key : ''];
      })));
      if (writesAtStart !== activeMapWritesRef.current) {
        if (activeMapRef.current.phase === 'loading') activeMapRef.current.phase = 'unknown';
        return;
      }
      const activeId = ((_resp$response3 = resp.response) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.csvColumnMapId) || null;
      Object.assign(activeMapRef.current, {
        phase: 'known',
        activeId
      });
      setActiveCsvColumnMapId(activeId);
      setIsActiveMapKnown(true);
      if (queuedId && !activeId) autoActivateMapping(queuedId);
    });
    store.allocations.getSubmeterBillingUnitMeterMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      const isRead = (resp === null || resp === void 0 ? void 0 : resp.isSuccessful) && Array.isArray(resp.response);
      if (isCurrent && !isRead) setTemplateRead('failed');
      if (isCurrent) setCountSettled(true);
      if (isRead) {
        const uniqueUnitIds = new Set(resp.response.map(e => e.unitId).filter(Boolean));
        setMeterIdsProvided(uniqueUnitIds.size);
      }
    });
    return () => {
      isCurrent = false;
    };
  }, [billingMethodType, utility.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAddTier = () => {
    setConsumptionTiers(prev => [...prev, {
      id: Date.now(),
      value: '',
      unit: unitOfMeasure
    }]);
  };
  const handleRemoveTier = id => setConsumptionTiers(prev => prev.filter(tier => tier.id !== id));
  const handleAddRate = rateData => setRates(prev => [...prev, _objectSpread({
    id: Date.now()
  }, rateData)]);
  const handleRemoveRate = id => setRates(prev => prev.filter(r => r.id !== id));
  const handleUpdateMapping = updatedMapping => setMappings(prev => prev.map(m => m.id === updatedMapping.id ? updatedMapping : m));
  const handleAddMapping = mappingData => {
    var _lookup$queuedId;
    if (!isMountedRef.current) return;
    setMappings(prev => [...prev, mappingData]);
    const lookup = activeMapRef.current;
    if (lookup.phase === 'loading') (_lookup$queuedId = lookup.queuedId) !== null && _lookup$queuedId !== void 0 ? _lookup$queuedId : lookup.queuedId = mappingData.id;else autoActivateMapping(mappingData.id);
  };
  const handleRemoveMapping = async id => {
    // Forget it before the delete is awaited: a config read landing meanwhile must not activate it.
    if (activeMapRef.current.queuedId === id) activeMapRef.current.queuedId = null;
    const resp = await store.allocations.deleteSubmeterBillingCsvMapAsync.run({
      id
    });
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    toast('success', {
      body: ['Mapping deleted!']
    });
    setMappings(prev => prev.filter(m => m.id !== id));
  };
  const _useState45 = useState([]),
    _useState46 = _slicedToArray(_useState45, 2),
    searchResultItems = _useState46[0],
    setSearchResultItems = _useState46[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.trim().length > 0) {
      if (searchUtilityProvidersHandler) {
        setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems([{
          id: 'createCustomProviderId',
          key: 'createCustomProviderKey',
          label: value + ' (add new provider)',
          inputName: value
        }, ...resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.key,
            key: item.key,
            label: item.value
          });
        })]);
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([{
      id: 'createCustomProviderId',
      key: 'createCustomProviderKey',
      label: value + ' (add new provider)',
      inputName: value
    }]);
  };
  const _useState47 = useState(utility.provider.isCustom || false),
    _useState48 = _slicedToArray(_useState47, 2),
    isCustomProviderMode = _useState48[0],
    setIsCustomProviderMode = _useState48[1];
  const _useState49 = useState(''),
    _useState50 = _slicedToArray(_useState49, 2),
    customProviderName = _useState50[0],
    setCustomProviderName = _useState50[1];

  // A plain render function, not a component type created in this render: the items keep their identity
  // across renders, so no render of this form closes an open dialog. Each item's key carries the values its
  // dialog seeds from, so a value that lands while the dialog is open re-keys the row: the dialog closes (anything
  // picked in it is lost) and the PM reopens it on the real value, instead of Save writing the old one back.
  const renderBillingSettingsList = () => {
    var _store$homeDashboardS5, _store$homeDashboardS6, _store$homeDashboardS7, _store$homeDashboardS8, _store$homeDashboardS9;
    const list = [{
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_id",
      key: "UtilityAccordion_bill_frequency_key_".concat(utility.billFrequencyType),
      value: BILL_FREQUENCY_NAME[utility.billFrequencyType],
      isActive: true,
      isDefault: true,
      action: billingOptionsOnSetup ? /*#__PURE__*/React.createElement(SetOnSetupNote, null) : /*#__PURE__*/React.createElement(BillFrequencyModal, {
        propertyUtility: utility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_allocation_method_id",
      // The key carries every value the dialog seeds from, so a value that lands while it is open re-keys it
      // (the dialog closes, anything picked is lost, and reopening seeds the real value) instead of letting
      // Save write the old one back.
      key: "UtilityAccordion_allocation_method_key_".concat(utility.allocationMethod, "_").concat((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.propertyBuildingSquare),
      value: isSubmeterEnabled && billingMethodType === 'SubMeter' ? CONSTANTS.ALLOCATION_METHODS.BySubmeter : CONSTANTS.ALLOCATION_METHODS[utility.allocationMethod] + "".concat((utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS6 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.propertyBuildingSquare) === 0 ? ' (Error: Property Sq. footage not defined!)' : ''),
      isDefault: isDefaultBySetting('allocationMethod'),
      isActive: true,
      isError: (utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS7 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.propertyBuildingSquare) === 0,
      action: billingOptionsOnSetup ? /*#__PURE__*/React.createElement(SetOnSetupNote, null) : isSubmeterEnabled && billingMethodType === 'SubMeter' ? null : /*#__PURE__*/React.createElement(AllocationMethodModal, {
        propertyUtility: utility,
        billingMethod: billingMethodType,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_id",
      key: "UtilityAccordion_handling_vacant_unit_key_".concat(utility.vacantUnitUsage),
      value: "".concat(t(VACANT_UNIT_USAGE_TO_TRANSLATE[utility.vacantUnitUsage])).concat(utility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? " (".concat(formatVacantUnitUsageLimitPercent(utility === null || utility === void 0 ? void 0 : utility.vacantUnitUsageLimit), "%)") : vacantUnitOccupantsSummarySuffix(t, utility.vacantUnitUsage, utility.vacantUnitOccupantsCount)),
      isDefault: isDefaultBySetting('vacantUnitUsage'),
      isActive: true,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        propertyUtility: utility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_id",
      key: "UtilityAccordion_common_area_deduction_key_".concat(utility.commonAreaDeduction, "_").concat((_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS8 !== void 0 && (_store$homeDashboardS8 = _store$homeDashboardS8.getUtilityInfoById(isEditing ? utility.utilityId : utility === null || utility === void 0 ? void 0 : utility.utilityTypeId)) !== null && _store$homeDashboardS8 !== void 0 && _store$homeDashboardS8.cad ? 'cad' : 'no_cad'),
      isDefault: isDefaultBySetting('commonAreaDeduction'),
      isActive: true,
      value: utility.commonAreaDeduction + '%',
      // isError: true, // NOTE: TBD if needed
      // customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        propertyUtility: utility,
        isEdit: isEditing,
        goodWillDeductionValue: utility.goodWillDeduction,
        defaultCadEnabled: (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.getUtilityInfoById(isEditing ? utility.utilityId : utility === null || utility === void 0 ? void 0 : utility.utilityTypeId)) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.cad
      })
    }, {
      title: t('general.goodwill_deduction'),
      id: "UtilityAccordion_good_will_deduction_id",
      key: "UtilityAccordion_good_will_deduction_key",
      value: utility.goodWillDeduction,
      isDefault: utility.goodWillDeduction === 5,
      utilityCAD: utility.commonAreaDeduction,
      onChangeCallback: val => utility.setGoodWillDeduction(Number(val)),
      submitCallback: () => {
        // console.log('itemSubmitCallback');
      },
      isGWD: true,
      isActive: true,
      isEditable: !isEditing,
      showInfo: isEditing,
      infoComponent: /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "info",
        title: t('add_new_property_flow.update_gwd_info'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        state: "info",
        type: "question"
      })))
    }];
    if (isSubmeterEnabled && billingMethodType !== 'RUBS') {
      var _store$homeDashboardS0, _store$homeDashboardS1;
      const totalUnits = ((_store$homeDashboardS0 = (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.selectedPropertyDetails()) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.details) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.unitSetup) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.units) !== null && _store$homeDashboardS0 !== void 0 ? _store$homeDashboardS0 : []).filter(u => u.id && u.name).length;
      const meterIdsValue = meterIdsProvided === 0 ? 'Not provided' : meterIdsProvided >= totalUnits ? 'All provided' : "Provided ".concat(meterIdsProvided, "/").concat(totalUnits);
      list.unshift({
        title: t('Meter IDs'),
        id: "UtilityAccordion_meter_ids_id",
        key: "UtilityAccordion_meter_ids_key_",
        value: meterIdsValue,
        warningValue: meterIdsProvided === 0,
        isActive: true,
        action: /*#__PURE__*/React.createElement(ProvideUnitMeterIDsModal, {
          utility: utility,
          propertyUtilityId: utility.id,
          hasMeterIds: meterIdsProvided > 0,
          activeMapping: mappings.find(m => m.id === activeCsvColumnMapId),
          templateState: templateState,
          onHasMeterIdsChange: setMeterIdsProvided
        })
      });
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _store$homeDashboardS10, _store$homeDashboardS11, _store$homeDashboardS12;
      const defaultGl = (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.details) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.glCodeSetup) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.glAccountExternalId;
      const customGl = (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.details) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.glCodeSetup) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.utilityGlAccounts) === null || _store$homeDashboardS11 === void 0 || (_store$homeDashboardS11 = _store$homeDashboardS11.find(ci => ci.propertyUtilityLivableId === (utility === null || utility === void 0 ? void 0 : utility.id))) === null || _store$homeDashboardS11 === void 0 ? void 0 : _store$homeDashboardS11.glAccountExternalId;
      list.push({
        title: t('Resident Charges GL Account (Income)'),
        id: "UtilityAccordion_gl_id",
        key: "UtilityAccordion_gl_key_".concat(utility === null || utility === void 0 ? void 0 : utility.id, "_").concat(customGl ? customGl : defaultGl),
        isDefault: !customGl || defaultGl === customGl,
        isActive: true,
        value: (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.details) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.glCodeSetup.getGlNameByCode(customGl ? customGl : defaultGl),
        action: /*#__PURE__*/React.createElement(GLModal, {
          propertyUtility: utility,
          savedValue: customGl ? customGl : defaultGl,
          onSaveAndClose: async glId => {
            var _store$homeDashboardS13;
            (_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.details) === null || _store$homeDashboardS13 === void 0 || _store$homeDashboardS13.glCodeSetup.updateUtilityGlAccounts(utility === null || utility === void 0 ? void 0 : utility.id, glId);
          },
          isEdit: isEditing
        })
      });
      if (store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
        var _store$homeDashboardS14, _store$homeDashboardS15, _store$homeDashboardS16;
        const defaultPayableGl = (_store$homeDashboardS14 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.details) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.glCodeSetup) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.accountsPayableGlAccountExternalId;
        const customPayableGl = (_store$homeDashboardS15 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.details) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.glCodeSetup) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.utilityGlAccounts) === null || _store$homeDashboardS15 === void 0 || (_store$homeDashboardS15 = _store$homeDashboardS15.find(ci => ci.propertyUtilityLivableId === (utility === null || utility === void 0 ? void 0 : utility.id))) === null || _store$homeDashboardS15 === void 0 ? void 0 : _store$homeDashboardS15.accountsPayableGlAccountExternalId;
        list.push({
          title: t('Accounts Payable GL Account (Expense)'),
          id: "UtilityAccordion_payable_gl_id",
          key: "UtilityAccordion_payable_gl_key_".concat(utility === null || utility === void 0 ? void 0 : utility.id, "_").concat(customPayableGl ? customPayableGl : defaultPayableGl),
          isDefault: !customPayableGl || defaultPayableGl === customPayableGl,
          isActive: true,
          value: (_store$homeDashboardS16 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS16 === void 0 || (_store$homeDashboardS16 = _store$homeDashboardS16.details) === null || _store$homeDashboardS16 === void 0 ? void 0 : _store$homeDashboardS16.glCodeSetup.getGlNameByCode(customPayableGl ? customPayableGl : defaultPayableGl),
          action: /*#__PURE__*/React.createElement(GLModal, {
            isPayable: true,
            propertyUtility: utility,
            savedValue: customPayableGl ? customPayableGl : defaultPayableGl,
            onSaveAndClose: async glId => {
              var _store$homeDashboardS17;
              (_store$homeDashboardS17 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS17 === void 0 || (_store$homeDashboardS17 = _store$homeDashboardS17.details) === null || _store$homeDashboardS17 === void 0 || _store$homeDashboardS17.glCodeSetup.updateUtilityAccountsPayableGlAccounts(utility === null || utility === void 0 ? void 0 : utility.id, glId);
            },
            isEdit: isEditing
          })
        });
      }
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEditing ? "List_ITEM_NEW_".concat(item.key) : "List_ITEM_".concat(item.key),
      item: item
    }));
  };
  const _useState51 = useState(undefined),
    _useState52 = _slicedToArray(_useState51, 2),
    newSelectedProviderData = _useState52[0],
    setNewSelectedProviderData = _useState52[1];
  const configureBillingTemplateBySelectedProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && (value === null || value === void 0 ? void 0 : value.id) === 'createCustomProviderId') {
      // toggle custom provider create
      setIsCustomProviderMode(true);
      setCustomProviderName(value.inputName || '');
      if (utility.id === 'NEW_UTILITY_TEMPLATE') {
        utility.configureProviderModelForNewTemplate({
          name: value.inputName,
          isCustom: true,
          utilities: null
        });
      }
      return;
    }
    if (value && (value !== null && value !== void 0 && value.id || value !== null && value !== void 0 && value.utilityProviderId)) {
      await store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id || value.utilityProviderId]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          var _singleElementOfArray;
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          await store.utilityProviders.getUtilityInfoAsync.run({
            utilityIds: (_singleElementOfArray = singleElementOfArray(resp.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.utilities.map(i => i.id)
          });
          setNewSelectedProviderData(_objectSpread({}, singleElementOfArray(resp.response)));
          // setIsCustomProviderMode(singleElementOfArray(resp.response).isCustom);
          utility.configureProviderModelForNewTemplate(singleElementOfArray(resp.response));
          setProviderSetupModalOpen(true);
          // if (utility.id === 'NEW_UTILITY_TEMPLATE') {
          //   // utility.removeUtilityType('all');
          // }
        }
      });
    }
  };
  const createUpdateCustomUtilityTemplate = async () => {
    var _utility$provider;
    const createEditCustomProvider = async _ref5 => {
      let isEditProvider = _ref5.isEditProvider,
        name = _ref5.name,
        website = _ref5.website,
        providerId = _ref5.providerId,
        genericUtilityTypesToAssign = _ref5.genericUtilityTypesToAssign;
      if (isEditProvider) {
        await store.utilityProviders.editCustomUtilityProvidersAsync.run({
          name,
          website,
          providerId,
          propertyId: store.homeDashboardStore.getCurrentProperty.id
        }, [utility.id]);
        return providerId;
      } else {
        const result = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
          name,
          website,
          propertyId: store.homeDashboardStore.getCurrentProperty.id,
          utilityTypeIds: genericUtilityTypesToAssign
        }, [utility.id]);
        const _ref6 = result || {},
          createdProviderId = _ref6.response,
          isSuccessful = _ref6.isSuccessful;
        if (isSuccessful) {
          return createdProviderId;
        }
      }
    };
    const createCustomUtilitiesAndApplyToProvider = async _ref7 => {
      let utilityName = _ref7.utilityName,
        allocationMethod = _ref7.allocationMethod,
        vacantUnitUsage = _ref7.vacantUnitUsage,
        vacantUnitAllocation = _ref7.vacantUnitAllocation,
        commonAreaDeduction = _ref7.commonAreaDeduction,
        providerIdToAttach = _ref7.providerIdToAttach;
      return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
        name: utilityName,
        defaultAllocationMethod: allocationMethod,
        defaultVacantUnitUsage: vacantUnitUsage,
        paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[vacantUnitAllocation],
        cad: !!commonAreaDeduction,
        utilityProviderId: providerIdToAttach
      }, [utility.id]);
    };
    let customProviderId;
    if (utility.id === 'NEW_UTILITY_TEMPLATE' && !((_utility$provider = utility.provider) !== null && _utility$provider !== void 0 && (_utility$provider = _utility$provider.utilityProviderId) !== null && _utility$provider !== void 0 && _utility$provider.length)) {
      // New utility + new custom provider: create provider and utility type
      customProviderId = await createEditCustomProvider({
        isEditProvider: false,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: undefined,
        genericUtilityTypesToAssign: utility.provider.utilities.map(i => i.utilityTypeId)
      });
      utility.provider.setUtilityProviderId(customProviderId);
      const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
        utilityName: utility.utilityType,
        allocationMethod: utility.allocationMethod,
        vacantUnitUsage: utility.vacantUnitUsage,
        vacantUnitAllocation: utility.vacantUnitAllocation,
        commonAreaDeduction: utility.commonAreaDeduction,
        providerIdToAttach: customProviderId
      });
      if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
        utility.updateUtilityTypeIdForNewCustomUtility(createdCustomUtilitiesResp.response);
      }
    } else if (utility.id === 'NEW_UTILITY_TEMPLATE') {
      var _utility$provider2, _utility$provider3;
      // New utility + existing custom provider: update provider and create utility type
      await createEditCustomProvider({
        isEditProvider: true,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: (_utility$provider2 = utility.provider) === null || _utility$provider2 === void 0 ? void 0 : _utility$provider2.utilityProviderId
      });
      const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
        utilityName: utility.utilityType,
        allocationMethod: utility.allocationMethod,
        vacantUnitUsage: utility.vacantUnitUsage,
        vacantUnitAllocation: utility.vacantUnitAllocation,
        commonAreaDeduction: utility.commonAreaDeduction,
        providerIdToAttach: (_utility$provider3 = utility.provider) === null || _utility$provider3 === void 0 ? void 0 : _utility$provider3.utilityProviderId
      });
      if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
        utility.updateUtilityTypeIdForNewCustomUtility(createdCustomUtilitiesResp.response);
      }
    } else {
      var _utility$provider4;
      // Existing utility + custom provider: only update provider, utility type already exists
      await createEditCustomProvider({
        isEditProvider: true,
        name: utility.provider.utilityProviderName,
        website: utility.provider.website,
        providerId: (_utility$provider4 = utility.provider) === null || _utility$provider4 === void 0 ? void 0 : _utility$provider4.utilityProviderId
      });
    }
    return {
      customProviderId
    };
  };
  const finalizeSavingAndFetchUpdates = unicIdsForReq => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates({
      forceUpdate: true,
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
    // NOTE: Causes LB-5116
    // store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
    //   useUnicInProgress: false,
    //   customUnicInProgress: unicIdsForReq,
    // });
  };
  const persistAssociatedVendor = async vendorAssociation => {
    if (!(vendorAssociation !== null && vendorAssociation !== void 0 && vendorAssociation.utilityProviderLivableId) || !(vendorAssociation !== null && vendorAssociation !== void 0 && vendorAssociation.vendorExternalId)) {
      return;
    }
    const resp = await store.vendors.associateVendorsAsync.run(vendorAssociation);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      await store.vendors.getVendorsByUtilityProviderIdAsync.run({
        utilityProviderId: vendorAssociation.utilityProviderLivableId
      });
    }
  };
  const updateUtilityGlCodes = async () => {
    var _store$homeDashboardS18;
    const glCodeSetup = (_store$homeDashboardS18 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS18 === void 0 || (_store$homeDashboardS18 = _store$homeDashboardS18.details) === null || _store$homeDashboardS18 === void 0 ? void 0 : _store$homeDashboardS18.glCodeSetup;
    if (!glCodeSetup || glCodeSetup.utilityGlAccountsPatchSemanticallyEqual()) {
      return;
    }
    let patchValue = glCodeSetup.getUtilityGlAccountsValueForPatch();
    if (!patchValue.length) {
      patchValue = toJS(glCodeSetup.utilityGlAccounts);
    }
    if (!patchValue.length) {
      return;
    }
    if (!store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
      patchValue = patchValue.map(_ref8 => {
        let accountsPayableGlAccountExternalId = _ref8.accountsPayableGlAccountExternalId,
          rest = _objectWithoutProperties(_ref8, _excluded);
        return rest;
      });
    }
    patchValue = glCodeSetup.normalizeUtilityGlAccountsForPatch(patchValue);
    await store.credentials.patchAppfolioPropertiesAsync.run({
      properties: [{
        propertyLivableId: store.homeDashboardStore.getCurrentProperty.id,
        utilityGlAccounts: {
          value: patchValue
        }
      }]
    });
    glCodeSetup.handleUtilityGlAccountsSave();
  };
  const createUpdateUtilityTemplate = async function () {
    var _store$homeDashboardS23, _store$homeDashboardS24;
    let _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      vendorAssociation = _ref9.vendorAssociation,
      _ref9$silent = _ref9.silent,
      silent = _ref9$silent === void 0 ? false : _ref9$silent;
    const afterUtilitySave = async () => {
      await updateUtilityGlCodes();
      await persistAssociatedVendor(vendorAssociation);
    };
    if (utility.id === 'NEW_UTILITY_TEMPLATE') {
      var _store$homeDashboardS19, _utility$provider5, _utility$provider7, _store$homeDashboardS21, _store$homeDashboardS22;
      // NOTE: Adding
      if (((_store$homeDashboardS19 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS19 === void 0 || (_store$homeDashboardS19 = _store$homeDashboardS19.selectedPropertyDetails()) === null || _store$homeDashboardS19 === void 0 || (_store$homeDashboardS19 = _store$homeDashboardS19.details) === null || _store$homeDashboardS19 === void 0 ? void 0 : _store$homeDashboardS19.getPropertyUtilityProvider((_utility$provider5 = utility.provider) === null || _utility$provider5 === void 0 ? void 0 : _utility$provider5.utilityProviderId)) === null) {
        var _store$homeDashboardS20, _utility$provider6;
        const addPropertyUtilityProviderAsyncResp = await store.properties.addPropertyUtilityProviderAsync.run({
          propertyId: (_store$homeDashboardS20 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS20 === void 0 ? void 0 : _store$homeDashboardS20.id,
          utilityProviderId: (_utility$provider6 = utility.provider) === null || _utility$provider6 === void 0 ? void 0 : _utility$provider6.utilityProviderId
        }, [utility.id]);
        if (addPropertyUtilityProviderAsyncResp !== null && addPropertyUtilityProviderAsyncResp !== void 0 && addPropertyUtilityProviderAsyncResp.isSuccessful) {
          console.log('addPropertyUtilityProviderAsyncResp', addPropertyUtilityProviderAsyncResp.response);
        }
      }
      const utilityTemplateReqObj = _objectSpread(_objectSpread({}, utility), {}, {
        id: utility.utilityId,
        utilityProviderId: (_utility$provider7 = utility.provider) === null || _utility$provider7 === void 0 ? void 0 : _utility$provider7.utilityProviderId,
        buildingIds: [(_store$homeDashboardS21 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS21 === void 0 ? void 0 : _store$homeDashboardS21.propertyBuildingId],
        vacantUnitUsageLimit: utility.vacantUnitUsageLimit / 100,
        customCommonAreaDeduction: utility.commonAreaDeduction,
        allocationMethod: isSubmeterEnabled && billingMethodType === 'SubMeter' ? ALLOCATION_METHOD.BySubmeter : utility.allocationMethod
      });
      delete utilityTemplateReqObj.provider;
      delete utilityTemplateReqObj.lastUpdateTime;
      delete utilityTemplateReqObj.utilityTypes;
      return store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.run({
        propertyId: (_store$homeDashboardS22 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS22 === void 0 ? void 0 : _store$homeDashboardS22.id,
        propertyUtilities: [utilityTemplateReqObj]
      }, [utility.id]).then(async () => {
        await afterUtilitySave();
        toast('success', {
          body: ['Utility template added!']
        });
        finalizeSavingAndFetchUpdates([utility.id]);
      });
    }
    // NOTE: Editing
    const updateAsync = silent ? store.propertyUtility.updateNewPropertyUtilityConfigSilentAsync : store.propertyUtility.updateNewPropertyUtilityConfigAsync;
    return updateAsync.run(_objectSpread(_objectSpread({}, utility), {}, {
      propertyUtilityId: utility.id,
      propertyId: (_store$homeDashboardS23 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS23 === void 0 ? void 0 : _store$homeDashboardS23.id,
      buildingIds: [(_store$homeDashboardS24 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS24 === void 0 ? void 0 : _store$homeDashboardS24.propertyBuildingId],
      vacantUnitUsageLimit: utility.vacantUnitUsageLimit / 100,
      customCommonAreaDeduction: utility.commonAreaDeduction,
      allocationMethod: isSubmeterEnabled && billingMethodType === 'SubMeter' ? ALLOCATION_METHOD.BySubmeter : utility.allocationMethod
    }), [utility.id]).catch(() => {
      updateAsync.clearReqUnicIds();
    }).then(async resp => {
      if (resp === undefined) return false;
      await afterUtilitySave();
      toast('success', {
        body: ['Utility template updated!']
      });
      finalizeSavingAndFetchUpdates([utility.id]);
      return true;
    });
  };
  const buildVendorAssociationPayload = (vendorExternalIdSnapshot, utilityProviderLivableIdOverride) => {
    var _utility$provider8;
    const vendorExternalId = vendorExternalIdSnapshot !== null && vendorExternalIdSnapshot !== void 0 ? vendorExternalIdSnapshot : store.vendors.tempData.vendorExternalId;
    if (!store.company.companyFeatureStore.isAppfolio || !store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
      return null;
    }
    const utilityProviderLivableId = utilityProviderLivableIdOverride !== null && utilityProviderLivableIdOverride !== void 0 ? utilityProviderLivableIdOverride : (_utility$provider8 = utility.provider) === null || _utility$provider8 === void 0 ? void 0 : _utility$provider8.utilityProviderId;
    if (!utilityProviderLivableId || !vendorExternalId) {
      return null;
    }
    return {
      utilityProviderLivableId,
      vendorExternalId
    };
  };
  const saveDisclosures = async () => {
    if (!isSubmeterEnabled || billingMethodType !== 'SubMeter' || !utility.id || utility.id === 'NEW_UTILITY_TEMPLATE' || !disclosures) {
      return null;
    }
    const resp = await store.propertyUtility.setSubmeterDisclosuresAsync.run(_objectSpread({
      propertyUtilityId: utility.id
    }, Object.fromEntries(DISCLOSURE_FIELDS.map(_ref0 => {
      let key = _ref0.key;
      return [key, disclosures[key].trim() || null];
    })))).catch(() => undefined);
    if (resp !== null && resp !== void 0 && resp.isSuccessful) return true;
    toast('error', {
      title: 'Utility not saved',
      body: ['The disclosures were not saved, so nothing was saved. Try again.']
    });
    return false;
  };
  const saveTemplate = async () => {
    if (billingMethodType === 'RUBS' && utility.allocationMethod === ALLOCATION_METHOD.BySubmeter) {
      toast('error', {
        title: 'Choose a RUBS method',
        body: ['Switching to RUBS needs an allocation method. Pick one, then save.']
      });
      return;
    }
    const disclosuresSaved = await saveDisclosures();
    if (disclosuresSaved === false) return;
    const vendorExternalIdSnapshot = store.vendors.tempData.vendorExternalId;
    // Snapshot the secret and drop it from the form immediately: everything below is async and the
    // modal starts closing in the finally block.
    const pendingCredential = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    const wasNewUtility = isNewUtility;
    let keepOpen = false;
    try {
      var _utility$provider9;
      let templateSaved;
      if (isCustomProviderMode || utility !== null && utility !== void 0 && (_utility$provider9 = utility.provider) !== null && _utility$provider9 !== void 0 && _utility$provider9.isCustom) {
        var _utility$provider0;
        await createUpdateCustomUtilityTemplate();
        const providerIdForVendor = (_utility$provider0 = utility.provider) === null || _utility$provider0 === void 0 ? void 0 : _utility$provider0.utilityProviderId;
        templateSaved = await createUpdateUtilityTemplate({
          vendorAssociation: buildVendorAssociationPayload(vendorExternalIdSnapshot, providerIdForVendor),
          silent: disclosuresSaved === true
        });
      } else {
        templateSaved = await createUpdateUtilityTemplate({
          vendorAssociation: buildVendorAssociationPayload(vendorExternalIdSnapshot),
          silent: disclosuresSaved === true
        });
      }
      if (templateSaved === false) {
        keepOpen = true;
        if (disclosuresSaved) {
          const lockMessage = getMethodLockRefusal(store.propertyUtility.updateNewPropertyUtilityConfigSilentAsync);
          toast('error', lockMessage ? {
            title: METHOD_LOCK_TOAST_TITLE,
            body: [lockMessage]
          } : {
            title: 'Utility not saved',
            body: ['The disclosures were saved, but the utility was not. Try again.']
          });
        }
        return;
      }
      // After the utility exists, never before - the credential row must reference a real
      // propertyUtilityId. A failure here is reported but does not undo the utility.
      if (wasNewUtility && canManageCredentials) {
        var _utility$provider1;
        await savePendingCredential({
          store,
          pending: pendingCredential,
          companyId,
          propertyId,
          utilityProviderId: (_utility$provider1 = utility.provider) === null || _utility$provider1 === void 0 ? void 0 : _utility$provider1.utilityProviderId,
          utilityTypeId: utility.utilityTypeId
        });
      }
    } catch (e) {
      console.error('handleTemplateSave', e);
    } finally {
      if (!keepOpen) handleClose();
    }
  };
  const handleTemplateSave = async () => {
    setIsSaving(true);
    try {
      await saveTemplate();
    } finally {
      setIsSaving(false);
    }
  };
  const fetchSavedUtilities = async function () {
    let _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref1$loadGlSettings = _ref1.loadGlSettings,
      loadGlSettings = _ref1$loadGlSettings === void 0 ? false : _ref1$loadGlSettings;
    store.addNewProperty.utilitiesSetupV2.setRentGlId('');
    store.addNewProperty.utilitiesSetupV2.setGlobalGlId('');
    store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId('');
    store.addNewProperty.utilitiesSetupV2.resetStoreToInitValues();
    if (loadGlSettings) store.credentials.resetUtilitiesGlSettings();
    const _await$Promise$all = await Promise.all([store.properties.getPropertyAsync.run({
        propertyId: store.homeDashboardStore.getCurrentProperty.id
      }), store.properties.getPropertyUtilityProvidersV3Async.run({
        propertyId: store.homeDashboardStore.getCurrentProperty.id,
        forceSelectedUpdate: true
      }, [store.homeDashboardStore.getCurrentProperty.id]).then(async getPropertyUtilityProvidersAsyncResp => {
        var _getPropertyUtilityPr;
        if (getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && getPropertyUtilityProvidersAsyncResp.isSuccessful && getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && (_getPropertyUtilityPr = getPropertyUtilityProvidersAsyncResp.response) !== null && _getPropertyUtilityPr !== void 0 && _getPropertyUtilityPr.length) {
          const UtProvidersIds = getPropertyUtilityProvidersAsyncResp.response.map(utProvider => utProvider.utilityProviderId);
          const getUtilityProvidersListDataAsyncRes = await store.utilityProviders.getUtilityProvidersListDataAsync.run({
            utilityProviderIds: UtProvidersIds
          });
          if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && getUtilityProvidersListDataAsyncRes.isSuccessful) {
            var _getUtilityProvidersL;
            if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && (_getUtilityProvidersL = getUtilityProvidersListDataAsyncRes.response) !== null && _getUtilityProvidersL !== void 0 && _getUtilityProvidersL.length) {
              getUtilityProvidersListDataAsyncRes === null || getUtilityProvidersListDataAsyncRes === void 0 || getUtilityProvidersListDataAsyncRes.response.forEach(utilityProvider => store.addNewProperty.utilitiesSetupV2.addProvider(utilityProvider, true));
              const vendorsPromises = [];
              getPropertyUtilityProvidersAsyncResp === null || getPropertyUtilityProvidersAsyncResp === void 0 || getPropertyUtilityProvidersAsyncResp.response.map(utilityProvider => {
                const matchingProvider = getUtilityProvidersListDataAsyncRes.response.find(i => i.id === utilityProvider.utilityProviderId);
                const utilitiesToUpdate = utilityProvider.utilities.map(cUtility => {
                  const matchUtility = matchingProvider.utilities.find(i => i.id === cUtility.utilityId);
                  cUtility.isCustom = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.isCustom;
                  cUtility.utilityTypeId = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.utilityTypeId;
                  return cUtility;
                });
                store.addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad([_objectSpread(_objectSpread({}, matchingProvider), {}, {
                  utilities: utilitiesToUpdate
                })], false);
                if (store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) {
                  vendorsPromises.push(store.vendors.getVendorsByUtilityProviderIdAsync.run({
                    utilityProviderId: utilityProvider.utilityProviderId
                  }));
                }
              });
              if (vendorsPromises.length) {
                for (const vendorPromise of vendorsPromises) {
                  await vendorPromise;
                }
              }
            }
          }
        }
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
      currentProperty = _await$Promise$all2[0];
    if (currentProperty && currentProperty.response && singleElementOfArray(currentProperty.response.buildings).buildingSquare) {
      store.addNewProperty.utilitiesSetupV2.changeSqFootage(singleElementOfArray(currentProperty.response.buildings).buildingSquare.toString());
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _glProperties$respons, _currentGlProperty$ut;
      const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
      const currentGlProperty = glProperties === null || glProperties === void 0 || (_glProperties$respons = glProperties.response) === null || _glProperties$respons === void 0 ? void 0 : _glProperties$respons.find(glItem => glItem.propertyLivableId === store.homeDashboardStore.getCurrentProperty.id);
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.rentGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setRentGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.rentGlAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.glAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setGlobalGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.glAccountExternalId);
      }
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.accountsPayableGlAccountExternalId) {
        store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.accountsPayableGlAccountExternalId);
      }
      if (loadGlSettings && currentGlProperty !== null && currentGlProperty !== void 0 && (_currentGlProperty$ut = currentGlProperty.utilityGlAccounts) !== null && _currentGlProperty$ut !== void 0 && _currentGlProperty$ut.length) {
        store.credentials.batchSetUtilitiesGlSettings(currentGlProperty.utilityGlAccounts, store.addNewProperty.utilitiesSetupV2.selectedUtilities);
      }
      await store.credentials.getGLAccountsAsync.run({
        applyToHomeDashboard: true
      });
    }
  };
  const getUtilityInfo = async ids => {
    const resp = await store.utilityProviders.getUtilityInfoAsync.run({
      utilityIds: ids
    });
    return resp;
  };
  const confirmUtilitySetup = async _ref10 => {
    let buildingsRespExt = _ref10.buildingsRespExt,
      propertySqFootage = _ref10.propertySqFootage;
    try {
      var _store$homeDashboardS25;
      const buildingsResp = buildingsRespExt !== undefined ? buildingsRespExt : await store.buildings.getBuildingAsync.run({
        propertyId: (_store$homeDashboardS25 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS25 === void 0 ? void 0 : _store$homeDashboardS25.id
      });
      const buildingIds = buildingsResp.isSuccessful && buildingsResp.response.map(item => item.id);
      const utilityProvidersPromises = [];
      for (const utilityProvider of store.addNewProperty.utilitiesSetupV2.utilityProviders) {
        var _store$homeDashboardS26;
        const providerToSave = {
          propertyId: (_store$homeDashboardS26 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS26 === void 0 ? void 0 : _store$homeDashboardS26.id,
          utilityProviderId: utilityProvider.id
        };
        if (!utilityProvider.isFetched) {
          utilityProvidersPromises.push(store.properties.addPropertyUtilityProviderAsync.run(providerToSave));
        }
      }
      await Promise.all(utilityProvidersPromises);
      const utilitiesToCreate = [];
      const utilitiesToSave = [];
      let isAllocationMethodBySquareFootageExist = false;
      for (const selectedUtility of store.addNewProperty.utilitiesSetupV2.selectedUtilities) {
        var _store$homeDashboardS27, _selectedUtility$vaca;
        if (selectedUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || selectedUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) isAllocationMethodBySquareFootageExist = true;
        const vacantUnitUsageLimit = selectedUtility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? store.addNewProperty.vacantUnitUsageLimit.get(selectedUtility.utilityId) / 100 || 0.3 : undefined;
        const utilityToSave = {
          id: selectedUtility.id,
          propertyUtilityId: selectedUtility.id,
          propertyId: (_store$homeDashboardS27 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS27 === void 0 ? void 0 : _store$homeDashboardS27.id,
          utilityProviderId: selectedUtility.utilityProviderId,
          utilityId: selectedUtility.utilityId,
          billFrequencyType: selectedUtility.billFrequencyType,
          allocationMethod: selectedUtility.allocationMethod,
          buildingIds: buildingIds,
          utilityCap: selectedUtility.utilityCap,
          customCommonAreaDeduction: selectedUtility.utilityCAD,
          vacantUnitAllocation: selectedUtility.vacantUnitAllocation,
          vacantUnitUsage: selectedUtility.vacantUnitUsage,
          vacantUnitOccupantsCount: (_selectedUtility$vaca = selectedUtility.vacantUnitOccupantsCount) !== null && _selectedUtility$vaca !== void 0 ? _selectedUtility$vaca : null,
          vacantUnitUsageLimit,
          goodWillDeduction: selectedUtility.goodWillDeduction
        };
        if (selectedUtility.isFetched && selectedUtility.isEnabled) {
          utilitiesToSave.push(utilityToSave);
        } else if (!selectedUtility.isFetched && selectedUtility.isEnabled) {
          if (selectedUtility.isCustom) {
            await store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
              name: selectedUtility.name,
              defaultAllocationMethod: selectedUtility.allocationMethod,
              defaultVacantUnitUsage: selectedUtility.vacantUnitUsage,
              paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[selectedUtility.vacantUnitAllocation],
              cad: selectedUtility.utilityCAD,
              utilityProviderId: selectedUtility.utilityProviderId
            }).then(async attachedUtilityResp => {
              if (attachedUtilityResp.isSuccessful) {
                var _attachedUtilityResp$, _attachedUtilityResp$2, _attachedUtilityResp$3;
                utilitiesToCreate.push(Object.assign(utilityToSave, {
                  id: (_attachedUtilityResp$ = attachedUtilityResp.response) === null || _attachedUtilityResp$ === void 0 ? void 0 : _attachedUtilityResp$.utilityId,
                  utilityId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$2 = attachedUtilityResp.response) === null || _attachedUtilityResp$2 === void 0 ? void 0 : _attachedUtilityResp$2.utilityId,
                  utilityTypeId: attachedUtilityResp === null || attachedUtilityResp === void 0 || (_attachedUtilityResp$3 = attachedUtilityResp.response) === null || _attachedUtilityResp$3 === void 0 ? void 0 : _attachedUtilityResp$3.utilityTypeId
                }));
              }
            });
          } else {
            utilitiesToCreate.push(utilityToSave);
          }
        }
      }
      const finalPromises = [];
      if (utilitiesToCreate && utilitiesToCreate.length) {
        var _store$homeDashboardS28;
        finalPromises.push(store.propertyUtility.addNewPropertyUtilityConfigBatchAsync.run({
          propertyId: (_store$homeDashboardS28 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS28 === void 0 ? void 0 : _store$homeDashboardS28.id,
          propertyUtilities: utilitiesToCreate
        }));
      }
      if (utilitiesToSave && utilitiesToSave.length) {
        var _store$homeDashboardS29;
        finalPromises.push(store.propertyUtility.updateNewPropertyUtilityConfigBatchAsync.run({
          propertyId: (_store$homeDashboardS29 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS29 === void 0 ? void 0 : _store$homeDashboardS29.id,
          propertyUtilities: utilitiesToSave
        }));
      }
      if (isAllocationMethodBySquareFootageExist && Number(propertySqFootage) >= 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) >= 0) {
        var _store$homeDashboardS30;
        const currentBuildingId = singleElementOfArray(buildingsResp.response).id;
        await store.properties.updatePropertyAsync.run({
          updateStore: true,
          propertyId: (_store$homeDashboardS30 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS30 === void 0 ? void 0 : _store$homeDashboardS30.id,
          buildings: [{
            buildingId: currentBuildingId,
            buildingSquare: Number(propertySqFootage) !== Number(store.addNewProperty.utilitiesSetupV2.sqFootage) && isValueNumber(propertySqFootage) ? Number(propertySqFootage) : Number(store.addNewProperty.utilitiesSetupV2.sqFootage)
          }]
        });
      }
      await Promise.all(finalPromises);
      await fetchSavedUtilities();
      if (store.credentials.utilitiesGlSettings.length > 0) {
        var _store$homeDashboardS31;
        const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
          selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
          defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
          includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
        });
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: (_store$homeDashboardS31 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS31 === void 0 ? void 0 : _store$homeDashboardS31.id,
            utilityGlAccounts: {
              value: cUtilityArray
            }
          }]
        });
      }
      if (store.addNewProperty.utilitiesSetupV2.utilityIds.length) await getUtilityInfo(store.addNewProperty.utilitiesSetupV2.utilityIds);
      if (store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates({
          forceUpdate: true
        });
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
          forceUpdate: true
        });
      } else {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchUtilityTemplates({
          forceUpdate: true
        });
      }
      if (store.company.companyFeatureStore.isAppfolio) {
        var _store$homeDashboardS32;
        (_store$homeDashboardS32 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS32 === void 0 || _store$homeDashboardS32.details.fetchPropertyAppfolioGlCodes({
          forceUpdate: true
        });
      }
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  };
  const saveUtilityProviderSetup = async function () {
    let _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      propertySqFootage = _ref11.propertySqFootage,
      createdUtilityProviderId = _ref11.createdUtilityProviderId,
      vendorExternalIdFromAddProvider = _ref11.vendorExternalIdSnapshot;
    try {
      var _store$homeDashboardS33, _ref12, _ref13, _utility$provider10, _store$addNewProperty, _ref14;
      const buildingsResp = await store.buildings.getBuildingAsync.run({
        propertyId: (_store$homeDashboardS33 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS33 === void 0 ? void 0 : _store$homeDashboardS33.id
      });
      if (store.company.companyFeatureStore.isAppfolio) {
        var _store$homeDashboardS34, _store$homeDashboardS35, _store$homeDashboardS36;
        const currentRentGl = {
          rentGlAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.rentGlAccountExternalId : null
          }
        };
        const currentglobalGl = {
          glAccountExternalId: {
            value: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId ? store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId : null
          }
        };
        const existingChargeOnDayOfMonth = (_store$homeDashboardS34 = (_store$homeDashboardS35 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS35 === void 0 || (_store$homeDashboardS35 = _store$homeDashboardS35.details) === null || _store$homeDashboardS35 === void 0 || (_store$homeDashboardS35 = _store$homeDashboardS35.glCodeSetup) === null || _store$homeDashboardS35 === void 0 ? void 0 : _store$homeDashboardS35.chargeOnDayOfMonth) !== null && _store$homeDashboardS34 !== void 0 ? _store$homeDashboardS34 : null;
        const chargeOnDayOfMonth = {
          value: existingChargeOnDayOfMonth
        };
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [_objectSpread(_objectSpread(_objectSpread({
            propertyLivableId: (_store$homeDashboardS36 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS36 === void 0 ? void 0 : _store$homeDashboardS36.id
          }, currentRentGl), currentglobalGl), {}, {
            chargeOnDayOfMonth
          })]
        });
      }
      if (store.credentials.utilitiesGlSettings.length > 0) {
        var _store$homeDashboardS37;
        const cUtilityArray = store.credentials.buildUtilityGlAccountsPatchValue({
          selectedUtilities: store.addNewProperty.utilitiesSetupV2.selectedUtilities,
          defaultGlAccountExternalId: store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId,
          includePayable: store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled
        });
        await store.credentials.patchAppfolioPropertiesAsync.run({
          properties: [{
            propertyLivableId: (_store$homeDashboardS37 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS37 === void 0 ? void 0 : _store$homeDashboardS37.id,
            utilityGlAccounts: {
              value: cUtilityArray
            }
          }]
        });
      }
      await confirmUtilitySetup({
        buildingsRespExt: buildingsResp,
        propertySqFootage
      });
      const providerIdForVendor = (_ref12 = (_ref13 = createdUtilityProviderId !== null && createdUtilityProviderId !== void 0 ? createdUtilityProviderId : utility === null || utility === void 0 || (_utility$provider10 = utility.provider) === null || _utility$provider10 === void 0 ? void 0 : _utility$provider10.utilityProviderId) !== null && _ref13 !== void 0 ? _ref13 : (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.selectedUtilities[0]) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.utilityProviderId) !== null && _ref12 !== void 0 ? _ref12 : null;
      const vendorExtForPersist = (_ref14 = vendorExternalIdFromAddProvider !== null && vendorExternalIdFromAddProvider !== void 0 ? vendorExternalIdFromAddProvider : store.vendors.tempData.vendorExternalId) !== null && _ref14 !== void 0 ? _ref14 : null;
      await persistAssociatedVendor(buildVendorAssociationPayload(vendorExtForPersist, providerIdForVendor || undefined));
    } catch (e) {
      console.log('error', e);
    }
  };
  const saveUtilityProvider = async () => {
    var _utility$provider11;
    setIsLoading(true);
    const configurator = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator;
    // Snapshot the secret and the chosen scope before any of the async work below.
    const pendingCredential = pendingCredentialRef.current;
    pendingCredentialRef.current = _objectSpread({}, EMPTY_PENDING_CREDENTIAL);
    const enabledUtilities = ((configurator === null || configurator === void 0 ? void 0 : configurator.utilities) || []).filter(item => item.isEnabled);
    // A credential scopes to exactly one property utility (the account row is unique per credential
    // and account number). With several utilities enabled at once there is no non-arbitrary choice,
    // so leave it unscoped rather than guess - savePendingCredential then declines and says so.
    // utilityId, not utilityTypeId: the configurator carries both and it is utilityId that ends up
    // on the created PropertyUtilities row. Verified against dev, where the two differ.
    const scopedUtilityTypeId = enabledUtilities.length === 1 ? enabledUtilities[0].utilityId || enabledUtilities[0].utilityTypeId : undefined;
    const providerIdForCredential = (configurator === null || configurator === void 0 ? void 0 : configurator.providerId) || ((_utility$provider11 = utility.provider) === null || _utility$provider11 === void 0 ? void 0 : _utility$provider11.utilityProviderId);
    store.addNewProperty.utilitiesSetupV2.addProvider(_objectSpread(_objectSpread({}, toJS(configurator)), {}, {
      id: toJS(configurator).providerId,
      name: toJS(configurator).providerName
    }), false);
    store.addNewProperty.utilitiesSetupV2.selectUtilities({
      utilities: toJS(configurator.utilities)
    });
    await saveUtilityProviderSetup({
      propertySqFootage: store.addNewProperty.utilitiesSetupV2.sqFootage
    });
    // After the utilities exist, never before - the credential row must reference a real
    // propertyUtilityId. A failure here is reported but does not undo the utilities.
    if (canManageCredentials) {
      await savePendingCredential({
        store,
        pending: pendingCredential,
        companyId,
        propertyId,
        utilityProviderId: providerIdForCredential,
        utilityTypeId: scopedUtilityTypeId
      });
    }
    setIsLoading(false);
    handleClose();
  };
  const getModalIsLoading = () => {
    var _store$propertyUtilit, _store$propertyUtilit2;
    return ((_store$propertyUtilit = store.propertyUtility.addNewPropertyUtilityConfigBatchAsync) === null || _store$propertyUtilit === void 0 || (_store$propertyUtilit = _store$propertyUtilit.inProgressUnicIds) === null || _store$propertyUtilit === void 0 ? void 0 : _store$propertyUtilit.includes(utility.id)) || ((_store$propertyUtilit2 = store.propertyUtility.updateNewPropertyUtilityConfigAsync) === null || _store$propertyUtilit2 === void 0 || (_store$propertyUtilit2 = _store$propertyUtilit2.inProgressUnicIds) === null || _store$propertyUtilit2 === void 0 ? void 0 : _store$propertyUtilit2.includes(utility.id)) || isSaving || setupWriting;
  };
  const handleNewProviderConfigChange = data => {
    store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration(data);
  };
  useEffect(() => {
    fetchSavedUtilities({
      loadGlSettings: true
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showAssociatedVendorSection = store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled && (isCustomProviderMode || !!((_utility$provider12 = utility.provider) !== null && _utility$provider12 !== void 0 && _utility$provider12.utilityProviderId));
  useEffect(() => {
    var _utility$provider13;
    if (!showAssociatedVendorSection) {
      return undefined;
    }
    const providerId = (_utility$provider13 = utility.provider) === null || _utility$provider13 === void 0 ? void 0 : _utility$provider13.utilityProviderId;
    if (providerId) {
      store.vendors.getVendorsByUtilityProviderIdAsync.run({
        utilityProviderId: providerId
      });
    }
    return () => {
      store.vendors.changeTempDataVendor(null);
      store.vendors.changeTempDataProperty(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAssociatedVendorSection, (_utility$provider14 = utility.provider) === null || _utility$provider14 === void 0 ? void 0 : _utility$provider14.utilityProviderId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_the_provider') : t('add_new_property_flow.provider')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_a_provider_of_the_utilities_that_are_mentioned_in_your_bill') : t('add_new_property_flow.provider_description'))), !isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    autoFocus: true,
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    disabled: isEditing,
    clearIcon: true,
    popupIcon: null,
    value: utility.provider.utilityProviderName || (newSelectedProviderData === null || newSelectedProviderData === void 0 ? void 0 : newSelectedProviderData.name),
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureBillingTemplateBySelectedProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      autoFocus: true
    }, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), isCustomProviderMode && isEditing && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: utility.provider.utilityProviderName,
    onChange: e => {
      utility.provider.setUtilityProviderName(e.target.value);
    },
    error: !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length,
    helperText: !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length && getRequiredTextMessage('Provide Name')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: utility.provider.website,
    onChange: e => {
      utility.provider.setWebsite(e.target.value);
    }
  })))), showAssociatedVendorSection && /*#__PURE__*/React.createElement("div", {
    className: "vendors"
  }, !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.link_associated_vendor_in_appfolio')), /*#__PURE__*/React.createElement(AssociatedVendor, {
    isModal: true,
    utilityProviderId: utility.provider.utilityProviderId,
    utilityProviderName: utility.provider.utilityProviderName
  })), isCustomProviderMode && !isEditing && /*#__PURE__*/React.createElement(AddProviderPlain, {
    provider: null,
    isEditMode: false,
    propertyId: store.homeDashboardStore.getCurrentProperty.id,
    hideNotEnabledExternal: false,
    onSave: saveUtilityProviderSetup,
    customName: customProviderName,
    handleClose: handleClose,
    isNewUtility: true
  }), (!!newSelectedProviderData || isCustomProviderMode && isEditing || utility.id !== 'NEW_UTILITY_TEMPLATE' || utility.id === 'NEW_UTILITY_TEMPLATE' && ((_utility$provider15 = utility.provider) === null || _utility$provider15 === void 0 || (_utility$provider15 = _utility$provider15.utilities) === null || _utility$provider15 === void 0 ? void 0 : _utility$provider15.length)) && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement(UtilitiesAutocomplete, {
    key: 'SelectedUtilitiesAutocompleteKey',
    id: 'SelectedUtilitiesAutocompleteId',
    utility: utility,
    currentProviderDataExt: newSelectedProviderData,
    isCustomProviderMode: isCustomProviderMode
  }), isBillingOptionsEnabled && (isNewUtility ? /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(SetupOnSaveNote, {
    typeName: utility.utilityType
  })) : /*#__PURE__*/React.createElement(UtilitySetupSection, {
    propertyUtilityId: propertyUtilityId,
    utilityTypeId: utility.utilityTypeId,
    propertyId: propertyId,
    provider: {
      utilityProviderId: (_utility$provider16 = utility.provider) === null || _utility$provider16 === void 0 ? void 0 : _utility$provider16.utilityProviderId,
      name: (_utility$provider17 = utility.provider) === null || _utility$provider17 === void 0 ? void 0 : _utility$provider17.utilityProviderName,
      isFetchable: isScraperSupportedProvider
    },
    onLinkRead: noteSetupRead,
    onLinked: takeSetupValues,
    onSavingChange: setSetupWriting,
    onPortalLoginShown: setSetupShowsLogin,
    onLinkReadFailed: setSetupUnread,
    disabled: getModalIsLoading(),
    className: classes.xlSection
  })), /*#__PURE__*/React.createElement(BillReadyDayField, {
    propertyUtilityId: propertyUtilityId,
    className: classes.xlSection
  }), isBillingOptionsEnabled ? null : /*#__PURE__*/React.createElement(ApPushSwitch, {
    propertyUtilityId: propertyUtilityId,
    className: classes.xlSection
  }), setupHoldsLogin ? null : /*#__PURE__*/React.createElement(UtilityCredentialSlot, {
    canManageCredentials: canManageCredentials,
    isAutomated: isScraperSupportedProvider,
    className: classes.xlSection,
    companyId: companyId,
    propertyId: propertyId,
    propertyUtilityId: propertyUtilityId,
    utilityProviderId: (_utility$provider18 = utility.provider) === null || _utility$provider18 === void 0 ? void 0 : _utility$provider18.utilityProviderId,
    utilityTypeId: utility.utilityId,
    providerName: (_utility$provider19 = utility.provider) === null || _utility$provider19 === void 0 ? void 0 : _utility$provider19.utilityProviderName,
    credential: utilityCredential,
    credentialState: credentialState,
    onChanged: loadCredential,
    pendingRef: pendingCredentialRef
  }), isProviderSetupModalOpen && !isEditing && !isCustomProviderMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ProviderSetupPlain, {
    externalIsOpen: true,
    handleConfigChange: handleNewProviderConfigChange,
    propertyId: store.homeDashboardStore.getCurrentProperty.id,
    utilityProviderId: (_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.providerId,
    isDetailsPage: true,
    isNewUtility: true
  })), (utility === null || utility === void 0 ? void 0 : utility.utilityType) !== null && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement(React.Fragment, null, isSubmeterEnabled && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Select billing method"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Select whether to use RUBS or the sub-meter billing method."), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    size: "small",
    value: billingMethodType,
    onChange: handleChangeMethodType,
    disabled: billingOptionsOnSetup
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "RUBS"
  }, "RUBS"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "SubMeter"
  }, "Sub-meter"))), false && billingMethodType !== 'RUBS' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Select unit of measure"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Select all of the utilities that are represented in your real bill."), /*#__PURE__*/React.createElement(Select, {
    size: "small",
    label: "Unit of measure",
    value: unitOfMeasure,
    onChange: handleUnitOfMeasureChange,
    style: {
      minWidth: 200
    },
    notched: false,
    displayEmpty: true,
    renderValue: val => val ? "".concat(val === 'gal' ? 'Gallons' : val, " (").concat(val, ")") : 'Unit of measure'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "gal"
  }, "Gallons (gal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "hcf"
  }, "HCF (hcf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kgal"
  }, "Kgal (kgal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "ccf"
  }, "CCF (ccf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kWh"
  }, "kWh (kWh)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "BTU"
  }, "BTU (BTU)"))), false && billingMethodType !== 'RUBS' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, "Define consumption tiers"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "If the charges varies based on the utility amount consumed define the thresholds."), consumptionTiers.map((tier, index) => /*#__PURE__*/React.createElement("div", {
    key: tier.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
      padding: '8px 12px',
      border: '1px solid #e0e0e0',
      borderRadius: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      minWidth: 104,
      fontWeight: 600
    }
  }, "Tier ", index + 1, " treshold"), /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    style: {
      width: 120
    },
    value: tier.value,
    onChange: e => setConsumptionTiers(prev => prev.map(ct => ct.id === tier.id ? _objectSpread(_objectSpread({}, ct), {}, {
      value: e.target.value
    }) : ct)),
    InputProps: unitOfMeasure ? {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, unitOfMeasure)
    } : undefined
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: () => handleRemoveTier(tier.id),
    style: {
      minWidth: 0,
      padding: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: handleAddTier
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Add tier"))), false && billingMethodType === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, "Define the rates"), rates.map(rate => /*#__PURE__*/React.createElement("div", {
    key: rate.id,
    style: {
      padding: '12px 16px',
      border: '1px solid #e0e0e0',
      borderRadius: 4,
      marginBottom: 8,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, rate.rateName), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "".concat(rate.rateType === 'charge' ? 'Charge' : 'Credit', " - ").concat(rate.rateIn).concat(rate.rateValue, " \xD7 ").concat(rate.ratePerUnit || '-'))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 4,
      flexShrink: 0,
      marginLeft: 8
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => handleRemoveRate(rate.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  })), /*#__PURE__*/React.createElement(IconButton, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))))), /*#__PURE__*/React.createElement(AddNewRateModal, {
    onSave: handleAddRate
  })), isSubmeterEnabled && billingMethodType === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, "Map columns"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Map your CSV meter read columns to our system's field names."), mappings.map(mapping => {
    var _store$homeDashboardS38;
    const isActive = activeCsvColumnMapId === mapping.id;
    return /*#__PURE__*/React.createElement("div", {
      key: mapping.id,
      className: isActive ? classes.activeMappingRow : classes.mappingRow
    }, /*#__PURE__*/React.createElement(MapColumnsViewModal, {
      mapping: mapping
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.mappingRowRight
    }, isActive ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.activeBadge
    }, "Active") : /*#__PURE__*/React.createElement(Button, {
      variant: "actionButtonInvert",
      size: "small",
      onClick: () => handleSetActiveMapping(mapping.id),
      disabled: store.propertyUtility.updateCsvColumnMapAsync.inProgress || !isActiveMapKnown
    }, "Set active"), /*#__PURE__*/React.createElement(MapColumnsEditModal, {
      mapping: mapping,
      propertyId: (_store$homeDashboardS38 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS38 === void 0 ? void 0 : _store$homeDashboardS38.id,
      utilityId: utility.utilityId,
      propertyUtilityId: utility.id,
      onSave: handleUpdateMapping
    }), isActive || !isActiveMapKnown ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: "To delete this mapping, set another mapping as active first",
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      disabled: true
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    })))) : /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => handleRemoveMapping(mapping.id)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    }))));
  }), /*#__PURE__*/React.createElement(MapColumnsModal, {
    propertyId: (_store$homeDashboardS39 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS39 === void 0 ? void 0 : _store$homeDashboardS39.id,
    utilityId: utility.utilityId,
    propertyUtilityId: utility.id,
    onSave: handleAddMapping
  })), isSubmeterEnabled && billingMethodType === 'SubMeter' && disclosures && /*#__PURE__*/React.createElement(SubmeterDisclosures, {
    className: classes.xlSection,
    values: disclosures,
    onChange: handleChangeDisclosure
  })), (utility === null || utility === void 0 ? void 0 : utility.utilityType) !== null && !isProviderSetupModalOpen && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.billing_settings')), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    id: "utility-content",
    "aria-controls": "utility-content",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContentTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.default_settings'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionContentIcon, " ").concat(isOpen ? 'open' : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "arrow-line-down"
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, renderBillingSettingsList())))))), !(isCustomProviderMode && !isEditing) && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disabled: getModalIsLoading(),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleClose();
    },
    'custom-attribute': '617-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: !isProviderSetupModalOpen && (getModalIsLoading() || (utility === null || utility === void 0 ? void 0 : utility.utilityId) === null || (utility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || utility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS40 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS40 === void 0 ? void 0 : _store$homeDashboardS40.propertyBuildingSquare) === 0 || isCustomProviderMode && !utility.provider.utilityProviderName && !utility.provider.utilityProviderName.length) || isProviderSetupModalOpen && (((_store$addNewProperty3 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty3 === void 0 ? void 0 : _store$addNewProperty3.utilities.filter(i => i.isEnabled).length) === 0 || ((_store$addNewProperty4 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.utilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod)).length) !== 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      if (isProviderSetupModalOpen) {
        saveUtilityProvider();
      } else {
        void handleTemplateSave();
      }
    },
    'custom-attribute': '618-new-billing-module'
  }, t('Save utility')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || getModalIsLoading()
  }));
});